/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BillingUsage,
  CompanyPlanAssignRequestRequest,
  CreditAdjustmentRequestRequest,
  CreditLedgerEntry,
  CreditPack,
  CreditPackRequest,
  ModeratorsBillingCompaniesLedgerRetrieveParams,
  ModeratorsBillingCreditPacksListParams,
  ModeratorsBillingPlansListParams,
  ModeratorsBillingSuccessFeesListParams,
  PaginatedCreditLedgerEntry,
  PaginatedCreditPack,
  PaginatedPlan,
  PaginatedSuccessFee,
  PatchedCreditPackRequest,
  PatchedPlanRequest,
  PatchedSuccessFeeRequest,
  Plan,
  PlanRequest,
  SuccessFee
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Plan, credit balance and usage this month. Any moderator.
 * @summary Company billing summary
 */
export const moderatorsBillingCompaniesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BillingUsage>(
      {url: `/api/v1/moderators/billing/companies/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsBillingCompaniesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/billing/companies/${id}/`] as const;
    }

    
export const getModeratorsBillingCompaniesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsBillingCompaniesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>> = ({ signal }) => moderatorsBillingCompaniesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsBillingCompaniesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>>
export type ModeratorsBillingCompaniesRetrieveQueryError = unknown

/**
 * @summary Company billing summary
 */
export const useModeratorsBillingCompaniesRetrieve = <TData = Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsBillingCompaniesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderator only. Adds (positive) or removes (negative) credits with a reason; the balance can't go below zero.
 * @summary Adjust a company's credits
 */
export const moderatorsBillingCompaniesAdjustCreate = (
    id: number,
    creditAdjustmentRequestRequest: CreditAdjustmentRequestRequest,
 ) => {
      
      
      return customInstance<CreditLedgerEntry>(
      {url: `/api/v1/moderators/billing/companies/${id}/adjust/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditAdjustmentRequestRequest
    },
      );
    }
  


export const getModeratorsBillingCompaniesAdjustCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>, TError,{id: number;data: CreditAdjustmentRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>, TError,{id: number;data: CreditAdjustmentRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>, {id: number;data: CreditAdjustmentRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsBillingCompaniesAdjustCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingCompaniesAdjustCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>>
    export type ModeratorsBillingCompaniesAdjustCreateMutationBody = CreditAdjustmentRequestRequest
    export type ModeratorsBillingCompaniesAdjustCreateMutationError = void

    /**
 * @summary Adjust a company's credits
 */
export const useModeratorsBillingCompaniesAdjustCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>, TError,{id: number;data: CreditAdjustmentRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingCompaniesAdjustCreate>>,
        TError,
        {id: number;data: CreditAdjustmentRequestRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingCompaniesAdjustCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Newest first. Any moderator. Paginated.
 * @summary Company credit ledger
 */
export const moderatorsBillingCompaniesLedgerRetrieve = (
    id: number,
    params?: ModeratorsBillingCompaniesLedgerRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedCreditLedgerEntry>(
      {url: `/api/v1/moderators/billing/companies/${id}/ledger/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsBillingCompaniesLedgerRetrieveQueryKey = (id: number,
    params?: ModeratorsBillingCompaniesLedgerRetrieveParams,) => {
    return [`/api/v1/moderators/billing/companies/${id}/ledger/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsBillingCompaniesLedgerRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>, TError = unknown>(id: number,
    params?: ModeratorsBillingCompaniesLedgerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsBillingCompaniesLedgerRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>> = ({ signal }) => moderatorsBillingCompaniesLedgerRetrieve(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsBillingCompaniesLedgerRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>>
export type ModeratorsBillingCompaniesLedgerRetrieveQueryError = unknown

/**
 * @summary Company credit ledger
 */
export const useModeratorsBillingCompaniesLedgerRetrieve = <TData = Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>, TError = unknown>(
 id: number,
    params?: ModeratorsBillingCompaniesLedgerRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesLedgerRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsBillingCompaniesLedgerRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderator only. `planCode: null` removes the assignment so the company falls back to the default plan.
 * @summary Assign a plan to a company
 */
export const moderatorsBillingCompaniesSetPlanCreate = (
    id: number,
    companyPlanAssignRequestRequest: CompanyPlanAssignRequestRequest,
 ) => {
      
      
      return customInstance<BillingUsage>(
      {url: `/api/v1/moderators/billing/companies/${id}/setPlan/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyPlanAssignRequestRequest
    },
      );
    }
  


export const getModeratorsBillingCompaniesSetPlanCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>, TError,{id: number;data: CompanyPlanAssignRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>, TError,{id: number;data: CompanyPlanAssignRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>, {id: number;data: CompanyPlanAssignRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsBillingCompaniesSetPlanCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingCompaniesSetPlanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>>
    export type ModeratorsBillingCompaniesSetPlanCreateMutationBody = CompanyPlanAssignRequestRequest
    export type ModeratorsBillingCompaniesSetPlanCreateMutationError = void

    /**
 * @summary Assign a plan to a company
 */
export const useModeratorsBillingCompaniesSetPlanCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>, TError,{id: number;data: CompanyPlanAssignRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingCompaniesSetPlanCreate>>,
        TError,
        {id: number;data: CompanyPlanAssignRequestRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingCompaniesSetPlanCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * All credit packs, active and inactive. Any moderator. Paginated.
 * @summary List credit packs
 */
export const moderatorsBillingCreditPacksList = (
    params?: ModeratorsBillingCreditPacksListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedCreditPack[]>(
      {url: `/api/v1/moderators/billing/credit-packs/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsBillingCreditPacksListQueryKey = (params?: ModeratorsBillingCreditPacksListParams,) => {
    return [`/api/v1/moderators/billing/credit-packs/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsBillingCreditPacksListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>, TError = unknown>(params?: ModeratorsBillingCreditPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsBillingCreditPacksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>> = ({ signal }) => moderatorsBillingCreditPacksList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsBillingCreditPacksListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>>
export type ModeratorsBillingCreditPacksListQueryError = unknown

/**
 * @summary List credit packs
 */
export const useModeratorsBillingCreditPacksList = <TData = Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>, TError = unknown>(
 params?: ModeratorsBillingCreditPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsBillingCreditPacksListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderator only. 1 credit = 1 match request.
 * @summary Create credit pack
 */
export const moderatorsBillingCreditPacksCreate = (
    creditPackRequest: CreditPackRequest,
 ) => {
      
      
      return customInstance<CreditPack>(
      {url: `/api/v1/moderators/billing/credit-packs/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditPackRequest
    },
      );
    }
  


export const getModeratorsBillingCreditPacksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>, TError,{data: CreditPackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>, TError,{data: CreditPackRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>, {data: CreditPackRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsBillingCreditPacksCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingCreditPacksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>>
    export type ModeratorsBillingCreditPacksCreateMutationBody = CreditPackRequest
    export type ModeratorsBillingCreditPacksCreateMutationError = void

    /**
 * @summary Create credit pack
 */
export const useModeratorsBillingCreditPacksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>, TError,{data: CreditPackRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingCreditPacksCreate>>,
        TError,
        {data: CreditPackRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingCreditPacksCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Super moderator only. Deactivate instead of deleting.
 * @summary Update credit pack
 */
export const moderatorsBillingCreditPacksPartialUpdate = (
    id: number,
    patchedCreditPackRequest: PatchedCreditPackRequest,
 ) => {
      
      
      return customInstance<CreditPack>(
      {url: `/api/v1/moderators/billing/credit-packs/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedCreditPackRequest
    },
      );
    }
  


export const getModeratorsBillingCreditPacksPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>, TError,{id: number;data: PatchedCreditPackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>, TError,{id: number;data: PatchedCreditPackRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>, {id: number;data: PatchedCreditPackRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsBillingCreditPacksPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingCreditPacksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>>
    export type ModeratorsBillingCreditPacksPartialUpdateMutationBody = PatchedCreditPackRequest
    export type ModeratorsBillingCreditPacksPartialUpdateMutationError = void

    /**
 * @summary Update credit pack
 */
export const useModeratorsBillingCreditPacksPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>, TError,{id: number;data: PatchedCreditPackRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingCreditPacksPartialUpdate>>,
        TError,
        {id: number;data: PatchedCreditPackRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingCreditPacksPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * All plans, active and inactive. Any moderator. Paginated.
 * @summary List plans
 */
export const moderatorsBillingPlansList = (
    params?: ModeratorsBillingPlansListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedPlan[]>(
      {url: `/api/v1/moderators/billing/plans/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsBillingPlansListQueryKey = (params?: ModeratorsBillingPlansListParams,) => {
    return [`/api/v1/moderators/billing/plans/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsBillingPlansListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsBillingPlansList>>, TError = unknown>(params?: ModeratorsBillingPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingPlansList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsBillingPlansListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsBillingPlansList>>> = ({ signal }) => moderatorsBillingPlansList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingPlansList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsBillingPlansListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingPlansList>>>
export type ModeratorsBillingPlansListQueryError = unknown

/**
 * @summary List plans
 */
export const useModeratorsBillingPlansList = <TData = Awaited<ReturnType<typeof moderatorsBillingPlansList>>, TError = unknown>(
 params?: ModeratorsBillingPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingPlansList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsBillingPlansListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderator only. Limits are per month; null = unlimited.
 * @summary Create plan
 */
export const moderatorsBillingPlansCreate = (
    planRequest: PlanRequest,
 ) => {
      
      
      return customInstance<Plan>(
      {url: `/api/v1/moderators/billing/plans/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: planRequest
    },
      );
    }
  


export const getModeratorsBillingPlansCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>, TError,{data: PlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>, TError,{data: PlanRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>, {data: PlanRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsBillingPlansCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingPlansCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>>
    export type ModeratorsBillingPlansCreateMutationBody = PlanRequest
    export type ModeratorsBillingPlansCreateMutationError = void

    /**
 * @summary Create plan
 */
export const useModeratorsBillingPlansCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>, TError,{data: PlanRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingPlansCreate>>,
        TError,
        {data: PlanRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingPlansCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Super moderator only. Deactivate instead of deleting.
 * @summary Update plan
 */
export const moderatorsBillingPlansPartialUpdate = (
    id: number,
    patchedPlanRequest: PatchedPlanRequest,
 ) => {
      
      
      return customInstance<Plan>(
      {url: `/api/v1/moderators/billing/plans/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPlanRequest
    },
      );
    }
  


export const getModeratorsBillingPlansPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>, TError,{id: number;data: PatchedPlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>, TError,{id: number;data: PatchedPlanRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>, {id: number;data: PatchedPlanRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsBillingPlansPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingPlansPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>>
    export type ModeratorsBillingPlansPartialUpdateMutationBody = PatchedPlanRequest
    export type ModeratorsBillingPlansPartialUpdateMutationError = void

    /**
 * @summary Update plan
 */
export const useModeratorsBillingPlansPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>, TError,{id: number;data: PatchedPlanRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingPlansPartialUpdate>>,
        TError,
        {id: number;data: PatchedPlanRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingPlansPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Success fees recorded on won, attributed deals (recorded only; nothing is charged). Filter with `status` (pending / void). Any moderator. Paginated.
 * @summary List success fees
 */
export const moderatorsBillingSuccessFeesList = (
    params?: ModeratorsBillingSuccessFeesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedSuccessFee[]>(
      {url: `/api/v1/moderators/billing/success-fees/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsBillingSuccessFeesListQueryKey = (params?: ModeratorsBillingSuccessFeesListParams,) => {
    return [`/api/v1/moderators/billing/success-fees/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsBillingSuccessFeesListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>, TError = unknown>(params?: ModeratorsBillingSuccessFeesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsBillingSuccessFeesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>> = ({ signal }) => moderatorsBillingSuccessFeesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsBillingSuccessFeesListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>>
export type ModeratorsBillingSuccessFeesListQueryError = unknown

/**
 * @summary List success fees
 */
export const useModeratorsBillingSuccessFeesList = <TData = Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>, TError = unknown>(
 params?: ModeratorsBillingSuccessFeesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsBillingSuccessFeesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super moderators can override `ratePercent` and `amount` per fee record (D2-2 — the pilot default is editable per fee).
 * @summary Edit a success fee
 */
export const moderatorsBillingSuccessFeesPartialUpdate = (
    id: number,
    patchedSuccessFeeRequest: PatchedSuccessFeeRequest,
 ) => {
      
      
      return customInstance<SuccessFee>(
      {url: `/api/v1/moderators/billing/success-fees/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSuccessFeeRequest
    },
      );
    }
  


export const getModeratorsBillingSuccessFeesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>, TError,{id: number;data: PatchedSuccessFeeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>, TError,{id: number;data: PatchedSuccessFeeRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>, {id: number;data: PatchedSuccessFeeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsBillingSuccessFeesPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsBillingSuccessFeesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>>
    export type ModeratorsBillingSuccessFeesPartialUpdateMutationBody = PatchedSuccessFeeRequest
    export type ModeratorsBillingSuccessFeesPartialUpdateMutationError = void

    /**
 * @summary Edit a success fee
 */
export const useModeratorsBillingSuccessFeesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>, TError,{id: number;data: PatchedSuccessFeeRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsBillingSuccessFeesPartialUpdate>>,
        TError,
        {id: number;data: PatchedSuccessFeeRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsBillingSuccessFeesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    